//gsap
import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);
export function blockHeroVideoAnimation() {
  document.addEventListener("DOMContentLoaded", function () {
    const heroVideoSection = document.querySelector(".blockHeroVideoAnimation");
    const videoContainer = document.querySelector(
      ".blockHeroVideoAnimation__video-container",
    );
    const header = document.querySelector("header");
    if (heroVideoSection && videoContainer) {
      const mm = gsap.matchMedia();

      mm.add("(min-width: 768px)", () => {
        const videoAnimation = gsap.timeline({
          scrollTrigger: {
            trigger: heroVideoSection,
            start: () => `top top+=${header.offsetHeight}`,
            end: "+=250%",
            pin: true,
            scrub: 2,
            pinSpacing: false,
            anticipatePin: 2,
            invalidateOnRefresh: true,
            onRefresh: (self) => {
              const nextSection = self.spacer.nextElementSibling;
              if (nextSection) {
                nextSection.style.marginTop = "150vh";
              }
            },
          },
        });

        videoAnimation
          .to(
            ".blockHeroVideoAnimation__text-content, .blockHeroVideoAnimation__logos",
            {
              y: "-100vh",
            },
            0,
          )
          .to(
            videoContainer,
            {
              width: "100vw",
              height: "110vh",
              borderRadius: 0,
              marginTop: 0,
              y: (index, target) => {
                const rect = target.getBoundingClientRect();
                const headerHeight =
                  document.querySelector("header")?.offsetHeight || 0;

                return -(rect.top - headerHeight);
              },
            },
            0,
          )
          .to(
            ".blockHeroVideoAnimation__video-wrapper",
            {
              paddingLeft: 0,
              paddingRight: 0,
            },
            0,
          )
          .to(
            ".blockHeroVideoAnimation__video",
            {
              borderRadius: 0,
            },
            0,
          )
          .to(".blockHeroVideoAnimation__video", {
            borderRadius: 0,
          });
      });
    }

    const initLogosInHero = () => {
      const tracks = document.querySelectorAll(
        ".blockHeroVideoAnimation__logos-track",
      );

      tracks.forEach((track) => {
        //position start, shaking reduction
        gsap.set(track, { x: 0, rotation: 0.01, force3D: true });

        const itemsCount = track.children.length;

        // base time for one element
        const baseDurationPerItem = 3;

        // dynamic animation time
        const dynamicDuration = itemsCount * baseDurationPerItem;
        const animation = gsap.to(track, {
          xPercent: -50,
          ease: "none",
          duration: dynamicDuration,
          repeat: -1,
        });
      });
    };
    window.addEventListener("load", initLogosInHero);
  });
}
